<template>
  <div class="modal-content-wrapper">
    <div class="header-building modal-bg">
      <img v-if="buildingImagePath" :src="buildingImagePath"/>
    </div>
    <div class="tech-city-detail-wrapper">
      <div class="tech-city-detail" @scroll.passive="handleScroll" ref="scrollParent">
        <div class="detail-info col-sm-4 col-12">
          <div class="info-header">
            <div class="header-right">
              <img v-if="buildingImagePath" :src="buildingImagePath" class="header-building" />
            </div>
            <div class="header-left">
              <img v-if="logo" :src="logo" class="header-logo" />
              <h1>{{ name }}</h1>
              <div class="header-categories" v-if="serviceCategory">
                <span v-for="(category, key) in serviceCategory" class="category-item" :key="key">
                  <a v-if="category" >{{category}}</a>
                </span>
              </div>
            </div>
          </div>
          <div class="info-mobile-container" :class="[{active: showInfo}]">
            <div class="info-content" v-if="fields">
              <div v-for="(field, key) in fields" class="info-item" :key="key" v-if="field.name && field.value">
                <div class="item-title">{{field.name}}</div>
                <span v-if="field.clickableField" class="item-detail" v-html="field.value" :ref="field.clickableField"></span>
                <span v-else class="item-detail" v-html="field.value"></span>
              </div>
            </div>
            <tech-city-social class="info-social" :companyUrl="companyUrl" :socialItems="socialItems"></tech-city-social>
          </div>
          <div class="info__show-more"
            @click="showInfo = !showInfo"
            v-gtm-tracker="{ec:'Inbound Clicks', ea:'China Tech City Overlay/Show more/Click', el: null}"
            >
            SHOW <span :class="[{'hidden': showInfo}]">MORE</span><span :class="[{'hidden': !showInfo}]">LESS</span> <svg-tc-read-more class="info-mobile-toggle" :class="[{active: showInfo}]"></svg-tc-read-more>
          </div>
        </div>
        <div class="detail-content col-sm-8 col-12">
          <div class="content-header">
            <h1 v-if="title">
              <node-link
                v-if="nid"
                :newPage="true"
                :url="node.relative_url"
                :type="node.type"
                :nid="node.nid"
                :title="title"
                v-gtm-tracker="{ec:'Inbound Clicks', ea:'China Tech City Overlay/Title/Click', el: node.relative_url}"
              >{{title}}</node-link></h1>
            <div class="header-detail">
              <span v-html="subheading.value" :ref="subheading.clickableField"></span>
              <template v-if="item.data_key === 'the-china-internet-report'">
                <a class="read-more"
                  v-gtm-tracker="{ec:'Inbound Clicks', ea:'China Tech City Overlay/Read more/Click', el: '/china-internet-report'}"
                  href="/china-internet-report"
                  target="_blank"
                >
                  Check Out Our Report<svg-tc-read-more class="arrow-right"></svg-tc-read-more>
                </a>
              </template>
              <template v-else>
                <node-link
                  v-if="nid"
                  :url="node.relative_url"
                  class="read-more"
                  :type="node.type"
                  :nid="node.nid"
                  :title="node.title"
                  v-gtm-tracker="{ec:'Inbound Clicks', ea:'China Tech City Overlay/Read more/Click', el: node.relative_url}"
                >
                  Read Full Story<svg-tc-read-more class="arrow-right"></svg-tc-read-more>
                </node-link>
              </template>
            </div>
          </div>
          <div class="middle-content-wrapper">
            <div class="content-quick-stats" v-if="stats.length">
              <h2>Quick Stats</h2>
              <div class="quick-stats-wrapper">
                <div class="quick-stats">
                  <tech-city-infographic
                    v-for="(stat, key) in stats"
                    :stat="stat"
                    :key="key"
                  ></tech-city-infographic>
                </div>
              </div>
            </div>
            <tech-city-fun-fact class="hidden-sm-down" v-if="showModal" :funFacts="funFacts" :class="{'no-animate': !stats.length}"></tech-city-fun-fact>
          </div>
          <tech-city-carousel
            v-if="!isEmpty(relatedNodes) && mounted"
            v-show="showCarousel"
            @carouselReady="showCarousel = true"
            :nids="relatedNodes"
            :title="name"
            :data_key="item.data_key"
            ></tech-city-carousel>
          <tech-city-fun-fact class="hidden-sm-up" v-if="showModal" :funFacts="funFacts"></tech-city-fun-fact>
          <div class="hidden-sm-up back-to-city-wrap">
            <div @click="$emit('closeModal')" class="back-to-city">
              <span class="back"><svg-arrow-left width="7" height="10"></svg-arrow-left></span>
              <span>Back</span>
            </div>
          </div>
          <div class="data-source data-source--mobile hidden-sm-up" v-if="showModal">
            Source: SCMP Data - March 2019
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SvgTcReadMore from 'static/svg/tc_read_more.svg'
  import SvgArrowLeft from 'static/svg/icon_arrow_left1.svg'
  import { mapState } from 'vuex'

  import get from 'lodash/get'
  import reduceRight from 'lodash/reduceRight'
  import map from 'lodash/map'
  import find from 'lodash/find'
  import fill from 'lodash/fill'
  import keys from 'lodash/keys'
  import pickBy from 'lodash/pickBy'
  import isEmpty from 'lodash/isEmpty'
  import startsWith from 'lodash/startsWith'
  import startCase from 'lodash/startCase'
  import upperCase from 'lodash/upperCase'
  import lowerCase from 'lodash/lowerCase'
  import isFinite from 'lodash/isFinite'
  import round from 'lodash/round'
  import floor from 'lodash/floor'
  import split from 'lodash/split'
  import filter from 'lodash/filter'
  import replace from 'lodash/replace'
  import includes from 'lodash/includes'
  import cloneDeep from 'lodash/cloneDeep'
  import uniq from 'lodash/uniq'
  import compact from 'lodash/compact'
  import reduce from 'lodash/reduce'
  import without from 'lodash/without'
  import take from 'lodash/take'

  import mounted from 'components/mixins/mounted'

  /**
   * @emits closeModal
   */

  export default {
    name: 'tech-city-detail',
    props: {
      item: {
        type: Object,
        required: true,
      },
      showModal: {
        type: Boolean,
        default: false,
      },
    },
    mixins: [mounted],
    components: {
      TechCityInfographic: () => import('components/tech-city/widgets/TechCityInfographic.vue'),
      TechCityCarousel: () => import('components/tech-city/widgets/TechCityCarousel.vue'),
      TechCitySocial: () => import('components/tech-city/overlay/TechCitySocial.vue'),
      TechCityFunFact: () => import('components/tech-city/overlay/TechCityFunFact.vue'),
      SvgTcReadMore,
      SvgArrowLeft,
    },
    computed: {
      ...mapState([
        'techCityImageData',
        'isNativeWrapper',
      ]),
      name() {
        return get(this, 'item.name', get(this, 'node.short_title', ''))
      },
      logo() {
        return this.$cacheBustedImageSrc(get(this, 'item.logo')) || '/static/icons/192x192.png'
      },
      headquarter() {
        return this.trimmedString(lowerCase(get(this, 'item.headquarter', '')))
      },
      serviceCategory() {
        return split(get(this, 'item.service_category', ''), ',') || []
      },
      revenue() {
        return map(pickBy(this.item, (value, key) => startsWith(key, 'revenue_')), (value = '', key) => {
          const trimmedValue = parseFloat(this.trimmedString(value), 10)
          return {
            currency: upperCase(key.replace('revenue', '')),
            value: isFinite(trimmedValue) ? trimmedValue : 0,
          }
        })
      },
      people() {
        return map(pickBy(this.item, (value, key) => startsWith(key, 'num_of')), (value = '') => {
          const trimmedValue = parseFloat(this.trimmedString(value), 10)
          const roundedValue = (floor(trimmedValue, -3) > 0) ? floor(trimmedValue, -3) : floor(trimmedValue, -2)
          const valueStrPlus = (roundedValue > 9000) ? `${roundedValue / 1000}k+` : `${(roundedValue + 1).toLocaleString()}+`
          let peopleNum = 0
          if (roundedValue < 10000) {
            peopleNum = round((roundedValue / 1000) / 2, +1)
          } else if (roundedValue < 50000) {
            peopleNum = round((roundedValue / 5000) / 2, +1) + 5
          } else if (roundedValue >= 50000) {
            peopleNum = round((roundedValue / 20000) / 2, +1) + 10
          }
          return {
            peopleNumber: isFinite(peopleNum) ? peopleNum : 0,
            value: isFinite(trimmedValue) ? valueStrPlus : 0,
          }
        })
      },
      fields() {
        return map(pickBy(this.item, (value, key) => startsWith(key, 'field_')), (value, key) => {
          const processedKey = startCase(key.replace('field_', ''))
          const processedValue = value
          let fieldData = {
            name: processedKey,
            value: processedValue,
          }

          if (includes(processedKey, 'Q And A')) {
            const splitQA = split(processedValue, '|')
            fieldData = {
              name: splitQA[0],
              value: splitQA[1],
            }
          }

          fieldData = this.formatClickableFieldNode(fieldData)
          fieldData = this.formatClickableFieldUrl(fieldData)

          return (includes(fieldData.value, '#N/A') || isEmpty(fieldData.value)) ? false : fieldData
        })
      },
      stats() {
        const revenue = this.formatRevenue(get(this, 'revenue[0].value', 0))
        const stats = []
        if (get(this, 'people[0].value', 0)) {
          stats.push({
            type: 'people',
            title: 'size',
            content: get(this, 'people[0].value', 0),
            footer: 'people',
            dataNum: get(this, 'people[0].peopleNumber', 0),
          })
        }

        if (includes(['beijing', 'hangzhou', 'shenzhen', 'shanghai', 'guangzhou'], this.headquarter)) {
          stats.push({
            title: 'headquarters',
            footer: this.headquarter,
            type: 'location',
            dataStr: this.headquarter,
          })
        }

        if (revenue.value) {
          stats.push({
            title: 'revenue',
            content: revenue.value,
            subText: revenue.des,
            footer: get(this, 'revenue[0].currency', ''),
            type: 'revenue',
            dataStr: 'svg-tc-revenue',
          })
        }

        return stats
      },
      socialItems() {
        const items = {
          LinkedIn: {
            url: get(this, 'item.linkedin_url'),
            icon: '/static/svg/raw/icon_linkedin.svg',
          },
          Twitter: {
            url: get(this, 'item.twitter_url'),
            icon: '/static/svg/raw/icon_twitter.svg',
          },
          Facebook: {
            url: get(this, 'item.facebook_url'),
            icon: '/static/svg/raw/icon_facebook.svg',
          },
        }
        return items
      },
      companyUrl() {
        const value = get(this, 'item.homepage_url', '')
        let processedValue = value.replace('http://', '')
        processedValue = processedValue.replace('https://', '')
        processedValue = processedValue.replace(/\/.*$/, '')

        const url = {
          url: value,
          processedUrl: processedValue,
        }
        return url
      },
      title() {
        return !isEmpty(get(this, 'item.info_title', '')) ? get(this, 'item.info_title') : get(this, 'node.title')
      },
      subheading() {
        let subheading = !isEmpty(get(this, 'item.info_description', '')) ? get(this, 'item.info_description') : get(this, 'node.subheading')
        subheading = { name: 'subheading', value: subheading }
        subheading = this.formatClickableFieldUrl(subheading)
        subheading = this.formatClickableFieldNode(subheading)
        return subheading
      },
      buildingImagePath() {
        const imageData = find(this.techCityImageData, ['dataKey', get(this, 'item.data_key')])
        const imageKey = get(imageData, 'imageKey')
        if (imageKey) {
          return this.$cacheBustedImageSrc(`/static/tech-city/images/buildings/${imageKey}.png`)
        }
        return false
      },
      relatedTermArticles() {
        const tid = get(this, 'item.related_term')
        const termQueue = this.$store.getters.termContentQueue(`taxonomy-term-content-${tid}`)
        return map(keys(termQueue), o => termQueue[o])
      },
      relatedArticles() {
        const tid = get(this, 'node.topics[0]')
        const relatedPersonQueue = this.$store.getters.nodeRelatedNodesQueue(`node-related-nodes-${this.nid}`)
        let queue = isEmpty(relatedPersonQueue) ? [] : map(keys(relatedPersonQueue), o => relatedPersonQueue[o])
        if (queue.length < 5) {
          const topicQueue = this.$store.getters.termContentQueue(`taxonomy-term-content-${tid}`)
          queue = [...queue, ...map(keys(topicQueue), o => topicQueue[o])]
        }
        return queue
      },
      relatedExplainers() {
        if (!isEmpty(this.node)) {
          return get(this, 'node.related_people', [])
        }
        return []
      },
      relatedNodes() {
        if (!isEmpty(this.relatedTermArticles) || !isEmpty(this.relatedExplainers) || !isEmpty(this.relatedArticles)) {
          return uniq([...this.relatedTermArticles, ...this.relatedExplainers, ...this.relatedArticles])
        }
        // Add dummy related node to show placeholder
        return fill(Array(5), 'loading')
      },
      funFacts() {
        return filter(map(pickBy(this.item, (value, key) => startsWith(key, 'fun_fact'))), value => !isEmpty(value))
      },
    },
    mounted () {
      this.fetchRelated(get(this, 'nid'))
    },
    methods: {
      isEmpty,
      getMappedQueue(queues) {
        return without(take(map(keys(queues), key => queues[key]), this.limit + 1), this.nid)
      },
      trimmedString(str) {
        return str.replace(/[,\s]/g, '')
      },
      formatRevenue(input) {
        const denominators = [
          {
            value: 1000,
            des: 'thousand',
          },
          {
            value: 1000000,
            des: 'million',
          },
          {
            value: 1000000000,
            des: 'billion',
          },
          {
            value: 1000000000000,
            des: 'trillion',
          },
        ]
        return reduceRight(denominators, (accum, denominator) => {
          if (!get(accum, 'done') && input > 0) {
            const val = get(accum, 'value') / denominator.value
            if (val >= 1) {
              return {
                done: true,
                value: round(val, 1),
                des: denominator.des,
              }
            }
          }
          return accum
        }, {
          done: false,
          value: input,
          des: '',
        })
      },
      fetchRelated(nid) {
        this.fetchingRelated = true
        const relatedNodePromise = () => (nid ? new Promise((resolve) => {
          this.$store.dispatch('fetchRelatedNodes', {
            type: 'person',
            nid,
            offset: this.offset,
            limit: this.limit,
          }).then(() => {
            const content = this.getMappedQueue(this.$store.getters.nodeRelatedNodesQueue(`node-related-nodes-${this.nid}`))
            resolve(content.length)
          })
        }) : Promise.resolve(0))

        const tidList = uniq(compact([get(this, 'item.related_term'), get(this, 'node.topics[0]')]))
        const taskList = [relatedNodePromise, ...map(tidList, tid => () => new Promise((resolve) => {
          this.$store.dispatch('fetchTaxonomyTermContent', { tid, offset: 0, limit: this.limit }).then(() => {
            const content = this.getMappedQueue(this.$store.getters.termContentQueue(`taxonomy-term-content-${tid}`))
            // Resolve the term content
            resolve(content.length)
          })
        }))]
        const promiseChain = reduce(
          taskList, (chain, task) => chain.then((length) => {
            this.count += length
            if (this.count < this.limit) {
              return task().then()
            }
            return Promise.resolve()
          }),
          Promise.resolve(0),
        )
        promiseChain.then(() => {
          this.loaded = true
          this.fetchingRelated = false
        })
      },
      handleScroll() {
        if (this.$refs.scrollParent.scrollTop > 0) {
          if (!this.firstScrollMobile) {
            this.showInfo = false
            this.firstScrollMobile = true
          }
        }
      },
      formatClickableFieldNode({name, value, clickableField = false}) {
        let counter = 0
        value = replace(value, new RegExp(/\[nid:(\d+)[^>](.*?)\[\/nid]/, 'gm'), (match, $1, $2) => {
          clickableField = `field_${name}`
          const nid = $1
          counter += 1
          const nextTickCounter = cloneDeep(counter)
          this.$nextTick(() => {
            const targetRef = get(this, `$refs['${clickableField}']`, {})
            const ele = get(targetRef, 'length', false) ? targetRef[0] : targetRef
            if (ele) ele.querySelector(`.node-${nid}-${nextTickCounter}`).addEventListener('click', e => this.handleClick(e, clickableField, nextTickCounter, nid, false))
          })
          return `<a href="#" class="node-${nid}-${counter}">${$2}</a>`
        })
        return {
          name,
          value,
          clickableField,
        }
      },
      formatClickableFieldUrl({name, value, clickableField = false}) {
        value = replace(value, new RegExp(/\[url:(.*?)\](.*?)\[\/url]/, 'gm'), (match, $1, $2) => {
          clickableField = `field_${name}`
          return `<a href="${$1}" target="_blank">${$2}</a>`
        })
        return {
          name: name || '',
          value,
          clickableField,
        }
      },
      handleClick(e, clickableField, nextTickCounter, nid, newPage = false) {
        e.preventDefault()
        this.$store.dispatch('fetchNode', {nid}).then(() => {
          const node = this.$store.getters.node(nid)
          const routeData = {
            type: node.type,
            nid: node.nid,
            url: node.relative_url,
            title: node.title,
            props: {
              nid: node.nid,
            },
          }
          window.open(routeData.url, '_blank')
          // if (newPage && get(routeData, 'url') && typeof window !== 'undefined' && !this.isNativeWrapper) {
          //   window.open(routeData.url, '_blank')
          // } else {
          //   this.$router.addRouteByNode({routeData}).then(() => {
          //     this.$router.push(routeData.url)
          //   })
          // }
        })
      },
    },
    data() {
      return {
        fetchingRelated: false,
        loaded: false,
        limit: 5,
        offset: 0,
        count: 0,
        showCarousel: false,
        showInfo: true,
        firstScrollMobile: false,
      }
    },
  }
</script>
<style scoped lang="scss">
  @mixin rose-text-and-links {
    color: $rose;
    /deep/ a {
      color: $rose;
    }
  }

  $boxShadow: rgba(0,0,0,0.3) 1px 1px 10px;
  $borderRadius: rem-calc(30);
  $transition: cubic-bezier(0.77, 0, 0.175, 1);
  $lineHeightNormal: 116.66666666666667%;

  .tech-city-detail {
    display: flex;
    width: auto;
    padding: 0;
    height: 100%;
    overflow: hidden;
    background: $white;
    line-height: $lineHeightNormal;

    $offsetTop: rem-calc(153);
    $offsetBottom: rem-calc(27);
    $mobileOffsetTop: rem-calc(73);

    @include respond-to("mobile") {
      overflow-y: auto;
      display: block;
      -webkit-overflow-scrolling: touch;
      transform: translate3d(0, 0, 0);
      overscroll-behavior: none;
      background: $another-gray;

      &:after  {
        content: " ";
        background: $white;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: rem-calc(300px);
      }
    }

    &-wrapper {
      height: calc(100vh - #{$offsetTop} - #{$offsetBottom} + 20px);
      border-radius: $borderRadius;
      background: $white;
      box-shadow: $boxShadow;
      overflow: hidden;
      -webkit-mask-image: -webkit-radial-gradient(white, black);
      @include respond-to("mobile") {
        height: calc(100vh - #{$mobileOffsetTop});
        border-radius: rem-calc(10);
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      @include respond-to("desktop") {
        max-height: rem-calc(950);
      }
    }
  }

  .detail-info {
    background: $another-gray;
    box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.3);
    z-index: 2;
    @include respond-to("desktop") {
      display: flex;
      flex-flow: column;
      padding: 0 rem-calc(22.5 15);
    }
    @include respond-to("hd") {
      padding: 0 rem-calc(35 15);
    }
    @include respond-to("mobile") {
      border-top-left-radius: rem-calc(10);
      border-top-right-radius: rem-calc(10);
      overflow: hidden;
      padding: 0 rem-calc(20);
      position: sticky;
      top: 0;
      z-index: 3;
      box-shadow: 0 -4px 0 4px $another-gray, 0 1px 5px rgba(0,0,0,.3);
    }
    .info-header {
      padding: rem-calc(0 2.5px);

      @include respond-to("hd") {
        padding: rem-calc(0 5);
      }
      @include respond-to("mobile") {
        padding: 0;
      }
      img {
        display: block;
        margin-bottom: 0;
      }
      .header-logo {
        background: $white;
        width: rem-calc(54);
        height: rem-calc(54);
        border-radius: 50%;
        float: left;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
        margin-right: rem-calc(6);
        margin-bottom: rem-calc(15);

        @include respond-to("hd") {
          width: rem-calc(72);
          height: rem-calc(72);
          margin-right: rem-calc(8);
          margin-top: rem-calc(6);
          margin-bottom: rem-calc(17);
        }

        @include respond-to("mobile") {
          float: none;
          width: rem-calc(48);
          height: rem-calc(48);
          margin-bottom: rem-calc(4);
          margin-top: rem-calc(0);
        }
      }
      @include respond-to("mobile") {
        .header-left {
          width: 50%;
          padding-top: rem-calc(10);

          img {
            transition: opacity .25s $transition .25s, max-height 0.25s $transition;
            max-height: rem-calc(150);
            will-change: max-height, opacity;
          }
        }
        .header-right {
          width: 50%;
          float: right;
          padding-right: rem-calc(24);

          img {
            transition: opacity .25s $transition .25s, max-height 0.25s $transition;
            max-height: rem-calc(150);
            will-change: max-height, opacity;
          }
        }
      }
      @include respond-to("desktop") {
        .header-right {
          margin: rem-calc(0 -5)
        }
      }
    }
    h1,
    .item-title,
    /deep/ .social-title {
      font-weight: bold;
      text-transform: uppercase;
      font-family: $barlow;
      line-height: $lineHeightNormal;
      color: $timeline-dark-gray;
      font-size: rem-calc(10);
      margin-top: rem-calc(9.5);
      margin-bottom: rem-calc(2);

      @include respond-to("hd") {
        font-size: rem-calc(14);
        margin-top: rem-calc(12);
        margin-bottom: rem-calc(3);
      }

      @include respond-to("mobile") {
        font-size: rem-calc(12);
          margin-bottom: rem-calc(3);
      }
    }
    /deep/ .social-title {
      margin-bottom: rem-calc(8.2);

      @include respond-to("hd") {
        margin-bottom: rem-calc(12);
      }
      @include respond-to("mobile") {
        margin-bottom: rem-calc(12);
      }
    }
    .item-title {
      color: $soft-rose;
      font-weight: 500;

      @include respond-to("mobile") {
        font-weight: bold;
      }
    }
    h1 {
      color: $outer-space;
      text-transform: none;
      font-size: rem-calc(22);
      line-height: $lineHeightNormal;
      margin: rem-calc(4 0 3 60);
      line-height: 100%;
      @include respond-to("hd") {
        font-size: rem-calc(32);
        margin: rem-calc(5 0 4 80);
      }
      @include respond-to("mobile") {
        margin: 0 0 rem-calc(2) 0;
      }
    }
    .info-item {
      margin: rem-calc(8) 0 rem-calc(11);

      @include respond-to("hd") {
        margin: rem-calc(12) 0 rem-calc(14);
      }

      @include respond-to("mobile") {
        margin: 0;
        width: 50%;
        float: left;
        padding-left: rem-calc(7.5);

        &:nth-child(odd) {
          clear: left;
          padding-left: 0;
          padding-right: rem-calc(7.5);
        }
      }
    }
    .header-categories {
      margin-left: rem-calc(60);
      line-height: 100%;
      margin-bottom: rem-calc(15);
      @include  respond-to("hd") {
        margin-left: rem-calc(80);
        line-height: $lineHeightNormal;
        margin-bottom: rem-calc(17);
      }
      @include respond-to("mobile") {
        margin-left: 0;
        line-height: $lineHeightNormal;
        margin-bottom: rem-calc(4);
      }
    }
    .item-detail {
      color: $darker-gray-2;

      /deep/ a {
        color: $darker-gray-2;
        text-decoration: underline;

        &:hover {
          color: $manatee2;
        }
      }
    }
    .category-item {
      font-size: rem-calc(13);
      line-height: 100%;
      color: $timeline-dark-gray;

      @include respond-to("hd") {
        font-size: rem-calc(18);
        line-height: $lineHeightNormal;
      }

      @include respond-to("mobile") {
        font-size: rem-calc(14);
        line-height: $lineHeightNormal;
      }

      a {
       color: $timeline-dark-gray;
      }

      &:after {
        content: ", ";
      }
      &:last-child:after {
        content: none;
      }
    }
    .item-detail {
      font-size: rem-calc(13);
      line-height: 125%;
      margin-top: rem-calc(1);

      @include respond-to("hd") {
        font-size: rem-calc(18);
      }

      @include respond-to("mobile") {
        margin-top: rem-calc(2);
        font-size: rem-calc(15);
        line-height: $lineHeightNormal;
      }
    }
    .info-content,
    .info-social {
      border-top: 1px solid $white;
      padding: rem-calc(0 2.5);

      @include respond-to("hd") {
        padding: rem-calc(0 5);
      }

      @include respond-to("mobile") {
        padding: 0;
        clear: both;
      }
    }

    .info-content {
      margin-top: 0;

      &:after {
        content: "";
        clear: both;
        display: table;
      }

      @include respond-to("mobile") {
        margin-top: rem-calc(10);
        border-top: none;
      }

      @include respond-to("desktop") {
        flex: 1 1 0;
        overflow-y: auto;
        margin-bottom: rem-calc(62);
      }

      @include respond-to("hd") {
        margin-bottom: rem-calc(86);
      }
    }
    .info-social {
      background: $another-gray;
      margin-top: rem-calc(23);

      @include respond-to("desktop") {
        position: absolute;
        bottom: 0;
        left: rem-calc(22.5);
        right: rem-calc(22.5);
        padding-bottom: rem-calc(30);
      }

      @include respond-to("hd") {
        left: rem-calc(30);
        right: rem-calc(30);
        padding-bottom: rem-calc(40);
      }

      @include respond-to("mobile") {
        margin-top: rem-calc(15);
      }

      a {
        margin-right: rem-calc(27);
      }
    }
  }

  .detail-content {
    color: $outer-space;
    padding: rem-calc(15 20 80);
    overscroll-behavior: none;
    background: $white;
    z-index: 1;
    @supports (-webkit-overflow-scrolling: touch) {
      @include respond-to("mobile") {
        padding-bottom: rem-calc(130);
      }
    }
    @include respond-to("mobile") {
      background: $white;
    }
    @include respond-to("desktop") {
      padding: rem-calc(18 22.5 29.3);
      overflow-x: hidden;
      overflow-y: auto;
      background: transparent;
    }
    @include respond-to("hd") {
      padding: rem-calc(24 30 36);
    }
    h1, .read-more {
      @include rose-text-and-links;
      font-family: $barlow;
    }
    h1 {
      font-size: rem-calc(15);
      line-height: $lineHeightNormal;
      font-weight: 500;
      margin-bottom: rem-calc(7);
      line-height: $lineHeightNormal;
      color: $soft-rose;

      @include  respond-to("hd") {
        font-size: rem-calc(20);
        margin-bottom: rem-calc(10);
      }

      @include respond-to("mobile") {
        font-size: rem-calc(16);
      }
    }
    .content-header h1 {
      font-weight: bold;
      color: $rose;
      font-size: rem-calc(18);

      @include respond-to("desktop") {
        font-size: rem-calc(17);
      }
      @include respond-to("hd") {
        font-size: rem-calc(20);
      }
    }
    .content-header {
      margin-bottom: rem-calc(11);
      @include respond-to("hd") {
        margin-bottom: rem-calc(20);
      }
      @include respond-to("mobile") {
        margin-bottom: rem-calc(30);
      }
      .header-detail {
        font-size: rem-calc(13);
        line-height: rem-calc(20);

        /deep/ {
          span {
            a {
              color: inherit;
              text-decoration: underline;
              &:hover {
                color: $manatee2;
              }
            }
          }
        }

        @include respond-to("hd") {
          font-size: rem-calc(18);
          line-height: rem-calc(27);
        }
        @include respond-to("mobile") {
          font-size: rem-calc(16);
          line-height: 144%;
        }
        /deep/ p {
          display: inline;
          font-size: rem-calc(13);
          line-height: rem-calc(20);

          @include respond-to("hd") {
            font-size: rem-calc(18);
            line-height: rem-calc(27);
          }
          @include respond-to("mobile") {
            font-size: rem-calc(16);
            line-height: 144%;
          }
        }
      }
      .read-more {
        font-size: rem-calc(14);
        line-height: 144%;
        font-weight: 500;
        fill: $rose;
        vertical-align: bottom;
        display: table;
        border: rem-calc(1) solid $rose;
        border-radius: rem-calc(20);
        margin-top: rem-calc(10);
        padding: rem-calc(4 10 4 16);
        &:hover {
          background-color: $rose;
          color: $white;
          text-decoration: none;
          svg {
            fill: $white;
          }
        }

        @include respond-to("desktop") {
          line-height: rem-calc(20);
          padding: rem-calc(0 10 0 16);
        }

        @include respond-to("hd") {
          line-height: rem-calc(27);
        }

        svg {
          display: inline-block;
          height: rem-calc(12);
        }
        .arrow-right {
          height: rem-calc(10.5);
          width: rem-calc(8);
          margin-left: rem-calc(7);
          animation: arrowBounce .75s infinite;

          @include respond-to("desktop") {
            width: rem-calc(6);
            margin-left: rem-calc(5)
          }

          @include respond-to("hd") {
            width: rem-calc(8);
            margin-left: rem-calc(7);
          }
        }
      }
    }

    .middle-content-wrapper {
      position: relative;
      .content-quick-stats {
        margin-bottom: rem-calc(24);

        @include respond-to("mobile") {
          margin-bottom: rem-calc(30);
        }

        h2 {
          @include respond-to("mobile") {
            margin-bottom: 0
          }
        }
      }
      .quick-stats {
        display: inline-block;
        padding: 0;
        margin-left: rem-calc(-5);
        @include respond-to("hd") {
          margin-left: rem-calc(-8);
        }
        @include respond-to("mobile") {
          display: flex;
          margin-left: rem-calc(-8);
        }
      }
      .infographic {
        /deep/ .infographic-title {
          color: $darker-gray-2;
        }

        /deep/ .infographic-background .add-color {
          fill: $rose;
          color: $rose;

          svg {
            fill: $rose;
          }
        }

        @include respond-to("mobile") {
          margin-top: rem-calc(8);
        }
      }
    }
  }

  .related-articles {
    display: inline-block;
    padding: rem-calc(0 20 0 30);
    white-space: nowrap;
  }

  .info__show-more {
    margin: rem-calc(15 -10 2);
    border-top: 1px solid rgba(0,0,0,0.1);
    padding: rem-calc(6 10);
    font-family: $barlow;
    font-size: rem-calc(12);
    line-height: $lineHeightNormal;
    font-weight: bold;
    color: $rose;
    cursor: pointer;
    line-height: $lineHeightNormal;

    .hidden {
      display: none;
    }

    @include respond-to("desktop") {
      display: none;
      margin: rem-calc(8 -10 2);
    }
  }

  .info-mobile-toggle {
    clear: both;
    margin-left: rem-calc(5);
    transform: rotate(90deg);
    transition: 250ms transform $transition;
    height: rem-calc(10);
    position: absolute;
    right: rem-calc(22);
    fill: $rose;
    margin-top: rem-calc(2);
    &.active {
      transform: rotate(-90deg);
    }
  }
  .info-mobile-container {
    clear: both;
    @include respond-to("mobile") {
      max-height: 0;
      overflow: hidden;
      transition: max-height .25s $transition;
      transform: translate3d(0, 0, 0);
      will-change: max-height;
      &.active {
        max-height: rem-calc(280);
        transition: max-height .25s $transition;
      }
    }
    @include respond-to("desktop") {
      display: flex;
      flex-flow: column;
      flex: 1 1 0;
    }
  }
  .header-building {
    margin: rem-calc(-35) auto 0;
    max-width: 100%;
    overflow: hidden;
    max-height: 32vh;
    display: block;

    @include  respond-to("mobile") {
      margin-top: rem-calc(-11);
    }

    &.modal-bg {
      position: absolute;
      top: 0;
      height: rem-calc(11);
      overflow: hidden;
      padding: 0 rem-calc(44) 0 0;
      width: 50%;
      right: 0;
      @include respond-to("desktop") {
        width: 33.333333%;
        height: rem-calc(35);
        padding: 0 rem-calc(22.5) 0;
        right: auto;
        left: 0;
      }
      @include respond-to("hd") {
        padding: 0 rem-calc(35) 0;
      }

      img {
        max-width: 100%;
        margin: 0 auto;
        max-height: 32vh;
        display: block;
        @include  respond-to("mobile") {
          transition: opacity .25s $transition .25s;
          opacity: 1;
          will-change: opacity;
          max-height: rem-calc(150);
        }
      }
    }
  }

  .data-source {
    font-family: $barlow;
    font-size: rem-calc(12);
    color: $timeline-dark-gray;
    margin-top: rem-calc(10);
    text-align: center;
    @include respond-to('mobile') {
      margin-top: rem-calc(19);
      font-weight: 500;
    }
  }

  .back-to-city-wrap {
    font-size: rem-calc(14);
    margin-top: rem-calc(24);
    color: $timeline-dark-gray;
    display: flex;
    justify-content: center;
    .back-to-city {
      padding: rem-calc(5 17);
      font-size: rem-calc(14);
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      border: rem-calc(1) solid $timeline-dark-gray;
      border-radius: rem-calc(60);
      span {
        line-height: rem-calc(17);
      }
      .back {
        fill: $timeline-dark-gray;
        margin-right: rem-calc(7);
        svg {
          display: block;
        }
      }
    }
  }

  @keyframes arrowBounce {
     0% {
       transform: translateX(rem-calc(-1px));
     }
     50% {
       transform: translateX(rem-calc(1px));
     }
     100% {
       transform: translateX(rem-calc(-1px));
     }
   }

</style>



// WEBPACK FOOTER //
// components/tech-city/overlay/TechCityDetail.vue